app.factory("Payments", ["$http",
    function ($http) {
        var Payment = {};

        Payment.studentPayments = function (studentId) {
            return $http.get("/payment/student/" + studentId).then(function (resp) {
                return resp.data;
            });
        };

        Payment.history = function () {
            return $http.get("/payment/history").then(function (resp) {
                return resp.data;
            });
        };

        Payment.scheduleList = function () {
            return $http.get("/payment/schedule/model").then(function (resp) {
                return resp.data;
            });
        };

        Payment.currentSchedule = function () {
            return $http.get("/payment/schedule/selected").then(function (resp) {
                return resp.data;
            });
        };

        Payment.getPayments = function () {
            return $http.get("/payment/payments").then(function (resp) {
                return resp.data;
            });
        };

        Payment.getAccruals = function () {
            return $http.get("/payment/accruals").then(function (resp) {
                return resp.data;
            });
        };

        Payment.updateSchedule = function (params) {
            return $http.post("/payment/schedule/model", params).then(function (resp) {
                return resp.data;
            });
        };

        return Payment;
    }
]);
